module.exports = __webpack_public_path__ + "static/img/1.12d7829.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/sp/1.png
// module id = dIfd
// module chunks = 0